import type { Violation } from "@vera/shared";
import { useFactPreviewStore } from "../stores/factPreviewStore";
import {
  getSelectedViolation,
  useViolationsStore,
} from "../stores/violationsStore";

/** Selected violation merged with unsaved form preview when ids match. */
export function useEffectiveSelectedViolation(): Violation | null {
  const selected = useViolationsStore(getSelectedViolation);
  const previewId = useFactPreviewStore(s => s.violationId);
  const preview = useFactPreviewStore(s => s.violation);

  if (!selected) return null;
  if (previewId === selected.id && preview) return preview;
  return selected;
}
